var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0672 5.26844C16.0672 7.90062 13.9334 10.0344 11.3012 10.0344C10.7124 10.0344 10.1484 9.92764 9.62778 9.73236L7.11026 12.2568H5.42553V13.9415H3.74079V15.5905H0.932861V12.7972L6.81801 6.88953C6.635 6.38349 6.53523 5.83762 6.53523 5.26844C6.53523 2.63625 8.66904 0.502441 11.3012 0.502441C13.9334 0.502441 16.0672 2.63625 16.0672 5.26844ZM14.3665 3.86093C14.3665 4.79126 13.6123 5.54544 12.682 5.54544C11.7517 5.54544 10.9975 4.79126 10.9975 3.86093C10.9975 2.9306 11.7517 2.17642 12.682 2.17642C13.6123 2.17642 14.3665 2.9306 14.3665 3.86093Z",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyOutline);
export default __webpack_public_path__ + "static/media/key-outline.210012d9ad5539599c96e1a6558adcc1.svg";
export { ForwardRef as ReactComponent };